import { client } from "./_base";

export const packhouse = client("producerpackhouse", item => ({
  ...item,
}));
